<!-- Btra Botones Extra -->

<!-- Propiedades que recibimos: -->
<!--    - btra_permisos: Objeto de permisos, consta de los siguientes elementos: -->
<!--       * mto: permisos de los btns de mto (Ejemplo: [1,1,1,1]) -->
<!--       * extra: permisos de los botones extra definidos en bd (Ejemplo: btn_pdf:1)-->

<!--    - btra_particular: Objeto con la definición de los botones particulares,  -->
<!--      la estructura es la siguiente: -->
<!--       * footer: { -->
<!--           extra: false / array de objetos de btns extra -->
<!--           mto: array de botones de mto  -->
<!--       * row: { (configuración para fila de grid)  -->
<!--           extra: false / array de objetos de btns extra -->
<!--           extraer: true / false -->
<!--           mto: array de btn de mto -->

<!--    - btra_modulo: nombre configuración v-bind (entorno) del btn  -->

<!-- Campos de la botones -->
<!--    - accion: nombre de la acción a ejecutar al pulsar en él -->
<!--    - texto: label (Opcional) -->
<!--    - styT: estilo del label (opcional) -->
<!--    - icono: icono (opcional) -->
<!--    - styI: estilo del icono (opcional) -->
<!--    - title: tooltip (opcional) -->
<!--    - botón: botón por defecto (contiene label, icono y tooltip) -->
<!--    - styB: estilo del botón (opcional) -->
<!--    - nopeso: objeto para definir el estado del botón: -->
<!--       * visible: true/false -->
<!--       * disabled: true/false -->
<!--    - show: 1/0. Si show es 0 la opción visible no lo habilita, tiene que estar a 1  -->
<!--      En última instancia son los permisos los que definen el valor de show -->

<!-- Funciones para modificar los botones:  -->
<!--    - btra_setView(accion, nopeso) -->
<!--      modifica el estado del botón (acción botón, {visible: true/false, disabled:true/false})  -->

<!--    - btra_modify(accion botón, {datos_a_modificar}) -->
<!--      le pasamos la propiedades a modificar, como objeto, y se modifican del botón indicado -->


<template>
    <div class="btraextra">
      <btra
          v-if="btra_particular"
          :btra_particular="mount_btra"
          :btra_modulo="btra_modulo"
          :nopesoShow="nopesoShow"
          @onEvent="event_btraextra">

            <template v-slot:btns_extra="{ Sitem }">
              <slot name="btns_extra" :Sitem="Sitem"></slot>
            </template>
      </btra>
    </div>
</template>



<script>

    import plugs from "@/common/general_plugs";
    const btra = () => plugs.groute("btra_new.vue", "comp");

    export default {
      components: { btra },
      props: {
        btra_permisos: { type: [Array, Object], required:true },
        btra_particular: { type: [Object, String], required:true },
        btra_modulo: { type: String, default: "standard" },
        nopesoShow: { type: Number, default: 0 }
      },

      computed: {

        // monto array de botones
        mount_btra() 
        {
          console.log('btra_particular: ', this.btra_particular);
          // extraigo la btra Extra y filtro por permisos
          var bp= this.get_btraExtra();
          return this.permisos_btns(bp);
        }

      },


      methods: {

        // gestor de eventos
        event_btraextra(evt) {
          console.log("*** event_btraextra. Emit btraextra: ", evt, " ***");
          this.$emit("onEvent", { accion: evt.accion });
        },


        // según btra_modulo extraigo el array de btns extra de la btra particular
        get_btraExtra() 
        {
          if (!this.btra_modulo) return [];

          // copio btra particular        
          let bp= this.btra2object();
          let btra_particular = [];

          // obtengo el array de btns extra según el tipo de módulo recibido
          switch (this.btra_modulo) {
            case "mrow":
            case "mtop":            
              if (bp.row["extra"] && bp.row["extra"] !== false) btra_particular= bp.row.extra;
              if (bp.row["extraer"] && bp.row["extraer"] !== false) btra_particular.concat({ accion: "extraer", btn: "btn_extraer", show: 1 });              
              break;

            default:            
              if (bp.footer["extra"] && bp.footer["extra"] !== false) btra_particular= bp.footer.extra;             
          }

          return btra_particular;          
        },


        // filtro botón por su permiso
        permisos_btns(btns) 
        {          
          btns.forEach(elem => {
            // si es un extra de un row, le añadimos 'row' al nombre del btn
            if (this.btra_modulo === "mrow") elem.btn = elem.btn + "_row";

            // si la acción es numérica, cogemos el permiso del array de Mto
            if (typeof elem.accion === "number") {
              elem.show = Number(this.btra_permisos.mto[elem.accion]);
              return;
            }

            // cogemos el permiso del array de botones Extra
            if (this.btra_permisos.extra[elem.accion]) {             
              elem.show = Number(this.btra_permisos.extra[elem.accion]);
              return;
            }

          });
         
          return btns;
        },

        // convierto la btra particular recibida como String en un Objeto
        btra2object() {          
          if (typeof this.btra_particular === "object") return this.btra_particular;        
          return this.$cfg.btra_tipo[this.btra_particular];        
        }
      }
    };
</script>
